import { PlatformFeature } from '../api';

export { PlatformFeature };

export const PLATFORM_FEATURES = PlatformFeature;

export type FeatureAccessMap = Record<PlatformFeature, boolean>;

export const createEmptyFeatureAccessMap = (): FeatureAccessMap => ({
  [PlatformFeature.Dashboard]: false,
  [PlatformFeature.NatalChart]: false,
  [PlatformFeature.Insights]: false,
  [PlatformFeature.AiChat]: false,
  [PlatformFeature.Compatibility]: false,
  [PlatformFeature.Social]: false,
  [PlatformFeature.Investments]: false,
  [PlatformFeature.CompatibilityLite]: false,
  [PlatformFeature.NatalReading]: false,
  [PlatformFeature.DailyReport]: false,
  [PlatformFeature.TransitReading]: false,
});
